export const CubeIcon = ({ disabled }: { disabled?: boolean }) => {
  return (
    <svg
      style={{ verticalAlign: 'middle' }}
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M4.8 10.55H9.6V5.75H4.8V10.55Z' fill={disabled ? '#9995943D' : 'var(--fow-primary-contrast-text)'} />
      <path d='M0 15.35H4.8V10.55H0V15.35Z' fill={disabled ? '#9995943D' : 'var(--fow-primary-contrast-text)'} />
      <path d='M4.8 20.15H9.6V15.35H4.8V20.15Z' fill={disabled ? '#9995943D' : 'var(--fow-primary-contrast-text)'} />
      <path d='M14.4 15.35H19.2V10.55H14.4V15.35Z' fill={disabled ? '#9995943D' : 'var(--fow-primary-contrast-text)'} />
      <path d='M19.2 10.55H24V5.75H19.2V10.55Z' fill={disabled ? '#9995943D' : 'var(--fow-primary-contrast-text)'} />
      <path d='M19.2 20.15H24V15.35H19.2V20.15Z' fill={disabled ? '#9995943D' : 'var(--fow-primary-contrast-text)'} />
    </svg>
  );
};
